import { FontWeight } from '@diritto/common/style/typography';
import styled from '@emotion/styled';
import { ProfileMenuItem, ProfileMenuItemProps } from 'app-components/accounts/profiles/menu/ProfileMenuItem';
import { ArrowIcon, ArrowNewIconProps } from 'icons/ArrowIcon';

interface ProfileMenuCollapseItemProps extends ProfileMenuItemProps {
  direction?: ArrowNewIconProps['direction'];
  showArrow?: boolean;
}

export const ProfileMenuCollapseItem = ({
  className,
  nickname,
  file,
  direction,
  onClick,
  showArrow = true,
}: ProfileMenuCollapseItemProps) => (
  <StyledProfileMenuItem
    className={className}
    nickname={nickname}
    file={file}
    fontWeight={FontWeight.Bold}
    onClick={onClick}>
    {showArrow && (
      <StyledIconWrapper>
        <ArrowIcon direction={direction} className="w-5 h-5" />
      </StyledIconWrapper>
    )}
  </StyledProfileMenuItem>
);

const StyledProfileMenuItem = styled(ProfileMenuItem)`
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const StyledIconWrapper = styled.div`
  display: flex;
`;
